import { useCategoryLibbyCall } from './CategoryBusinessGenerated';
import { Category } from '../../models';

export const useCategory = () => useCategoryLibbyCall<Category[]>({ methodName: 'getAll' });
